module.exports = __webpack_public_path__ + "static/jianyu1-cfef4cb52d6df2f2093b3e298ce2bbb3.jpg";